var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menus-admin"},[_c('menus',{attrs:{"menuCode":"DEALER_WEBSITE_MENUS","showLinkType":true}}),_c('help-popup',{attrs:{"helpLink":{75:'Website Menus', 101:'Website Template: Page Menu and Product Menu', 102:'Website Template: Footer Menu'},"tours":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }